const hideSidebarAndAction = () => {
    const footerObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            toggleElements(entry.isIntersecting);
        });
    });

    const footer = document.querySelector('#footer');
    footerObserver.observe(footer);

    const productAction = document.querySelector('.product-action');
    const sideNav = document.querySelector('.side-navigator');

    function toggleElements(footerIsVisible) {
        if (footerIsVisible) {
            if (productAction) productAction.classList.add('--hide-footer');
            if (sideNav) sideNav.classList.add('--hide-footer');
        } else {
            if (productAction) productAction.classList.remove('--hide-footer');
            if (sideNav) sideNav.classList.remove('--hide-footer');
        }
    }
};

hideSidebarAndAction();
